import { Modal } from "@msys/ui";
import React from "react";
import { useTranslate } from "@tolgee/react";
import { CrmPersonEditForm } from "./CrmPersonEditForm.js";
import { Link } from "react-router-dom";

interface Props {
  crmCompanyId: string;
  crmPersonId: string;
  handleClose: () => void;
}

export const CrmPersonEditModal = ({
  crmCompanyId,
  crmPersonId,
  handleClose,
}: Props) => {
  const { t } = useTranslate(["CrmUsers", "Global"]);
  return (
    <Modal
      handleClose={handleClose}
      title={t("Edit CRM contact person record", { ns: "CrmUsers" })}
      actionButtons={[
        {
          label: t("Go to CRM contact person page", { ns: "CrmUsers" }),
          buttonProps: {
            variant: "text",
            component: Link,
            // @ts-ignore
            to: `/crm/organisations/${crmCompanyId}/users/${crmPersonId}`,
          },
        },
      ]}
    >
      <CrmPersonEditForm crmPersonId={crmPersonId} />
    </Modal>
  );
};
